module.exports = __webpack_public_path__ + "img/bg-c.6852d2b4.png";